module.exports = new __parcel__URL__("halo-reach.6b8226a5.jpg").toString();